export default __webpack_public_path__ + "assets/1c5bd9c7ee9a7beb723c411d23d7a6b4.svg";